import api from './index';

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Error de API:', error);
    return Promise.reject(error);
  }
);

export default {
  // Obtener todas los operadores
  async getOperators() {
    try {
      const response = await api.get('/operadores');
      return response.data;
      
    } catch (error) {
      console.error('Error al obtener operadores:', error);
      throw error;
    }
  },
};